import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPause: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPause"><Path d="M4 3V21H10V3H4Z" fill="currentColor"/><Path d="M14 3V21H20V3H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPause;
